var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Gadget } from '../libs/gadgets.class';
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table(id, data) {
        var _this = _super.call(this) || this;
        _this.THColumns = "";
        _this.DTColumns = [];
        _this._expand = false;
        _this._tag = "none";
        _this.lastRow = undefined;
        _this.lastArrow = undefined;
        _this.Id = id;
        _this.Data = data;
        return _this;
    }
    Table.prototype.setColumns = function (header, useExpand) {
        var _this = this;
        if (useExpand === void 0) { useExpand = false; }
        var th = "";
        var dt = [];
        if (useExpand) {
            this.useExpand();
            th = '<th><i class="arrow right"></i></th>';
            dt.push({
                className: this._tag + " pointer",
                orderable: false,
                data: null,
                defaultContent: '<i class="table-arrow right"></i>'
            });
        }
        header.forEach(function (h) {
            if (_this._expand) {
                if (h.class == undefined)
                    h.class = "";
                h.class += _this._tag + " pointer";
            }
            var style = h.style !== undefined ? "style=\"".concat(h.style, "\"") : ' ';
            var classes = h.class !== undefined ? h.class : '';
            th += "<th ".concat(style, ">").concat(h.name, "</th>");
            dt.push({ data: h.data, class: classes });
        });
        this.THColumns = th;
        this.DTColumns = dt;
    };
    Table.prototype.execute = function (initComplete, order) {
        var _order = this._expand ? [[1, "asc"]] : [[0, "asc"]];
        this.table = $('#' + this.Id).DataTable({
            language: {
                url: 'german.json',
            },
            //responsive: true,
            //deferRender: true,
            autoWidth: true,
            data: this.Data,
            columns: this.DTColumns,
            order: order ? order : _order,
            preDrawCallback: function (settings) {
                //let table = settings.oInstance.api();
                //$(table.table().container()).css('display', 'none');
            },
            initComplete: function (settings) {
                //let table = settings.oInstance.api();
                //$(table.table().container()).css('display', 'block');
                initComplete();
            }
        });
    };
    Table.prototype.useExpand = function () {
        this._expand = true;
        this._tag = "tag" + Math.random().toString(36).slice(2);
    };
    Table.prototype.onRowClick = function (fn, late) {
        var _this = this;
        $('td.' + this._tag).on('click', function (e) {
            var tr = e.target.closest('tr');
            var row = _this.table.row(tr);
            var arrow = $(tr).find('.table-arrow');
            if (row.child.isShown()) {
                if (arrow.length > 0)
                    arrow.removeClass('down').addClass('right');
                _this.lastRow = undefined;
                _this.lastArrow = undefined;
                $('div.table-slider', row.child()).slideUp(150, function () {
                    row.child.hide();
                });
            }
            else {
                if (_this.lastRow != undefined) {
                    if (_this.lastArrow.length > 0)
                        _this.lastArrow.removeClass('down').addClass('right');
                    var _hideRow_1 = _this.lastRow;
                    $('div.table-slider', _hideRow_1.child()).slideUp(150, function () {
                        _hideRow_1.child.hide();
                    });
                    _this.lastRow = undefined;
                    _this.lastArrow = undefined;
                }
                // let _hideOther = $('.table-arrow.down').closest('tr')
                // let _hideRow = this.table.row(_hideOther)
                // if (_hideOther != undefined) {
                //     $('div.table-slider', this.table.row(_hideOther).child()).slideUp(150, () => {
                //         _hideRow.child.hide()
                //     })
                // }
                row.child('<div class="table-slider">' + fn(row.data()) + '<div>', 'no-padding').show();
                $('div.table-slider', row.child()).slideDown(150);
                _this.lastRow = row;
                _this.lastArrow = arrow;
                if (late != undefined)
                    late(row.data(), row);
                if (arrow.length > 0)
                    arrow.removeClass('right').addClass('down');
            }
        });
    };
    Table.prototype.render = function (forceParseGadgets) {
        return "<table id=\"".concat(this.Id, "\" class=\"table table-striped table-bordered align-middle table-hover\" style=\"width:100%\"><thead><tr>").concat(this.THColumns, "</tr></thead></table>");
    };
    return Table;
}(Gadget));
export { Table };
